(function (scope, factory) {
  'use strict';
  var api = factory();
  scope.RwadyCheckoutAddresses = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var provinceAliases = {
    anbar: 'Anbar', 'al anbar': 'Anbar', AN: 'Anbar', 'الأنبار': 'Anbar', 'الانبار': 'Anbar',
    basra: 'Basra', basrah: 'Basra', 'al basrah': 'Basra', BA: 'Basra', 'البصرة': 'Basra',
    nineveh: 'Nineveh', ninawa: 'Nineveh', mosul: 'Nineveh', NI: 'Nineveh', 'نينوى': 'Nineveh', 'الموصل': 'Nineveh',
    erbil: 'Erbil', arbil: 'Erbil', AR: 'Erbil', 'أربيل': 'Erbil', 'اربيل': 'Erbil',
    sulaymaniyah: 'Sulaymaniyah', suleimaniya: 'Sulaymaniyah', 'as sulaymaniyah': 'Sulaymaniyah', SU: 'Sulaymaniyah', 'السليمانية': 'Sulaymaniyah',
    duhok: 'Duhok', dahuk: 'Duhok', DA: 'Duhok', 'دهوك': 'Duhok',
    kirkuk: 'Kirkuk', KI: 'Kirkuk', 'كركوك': 'Kirkuk',
    najaf: 'Najaf', 'an najaf': 'Najaf', NA: 'Najaf', 'النجف': 'Najaf',
    karbala: 'Karbala', KA: 'Karbala', 'كربلاء': 'Karbala',
    baghdad: 'Baghdad', BG: 'Baghdad', 'بغداد': 'Baghdad',
    babylon: 'Babil', babil: 'Babil', BB: 'Babil', 'بابل': 'Babil',
    wasit: 'Wasit', WA: 'Wasit', 'واسط': 'Wasit',
    diyala: 'Diyala', DI: 'Diyala', 'ديالى': 'Diyala',
    maysan: 'Maysan', missan: 'Maysan', MA: 'Maysan', 'ميسان': 'Maysan',
    'dhi qar': 'Dhi Qar', dhiqar: 'Dhi Qar', DQ: 'Dhi Qar', 'ذي قار': 'Dhi Qar', 'ذيقار': 'Dhi Qar',
    qadisiyah: 'Qadisiyah', qadisiya: 'Qadisiyah', 'al qadisiyah': 'Qadisiyah', QA: 'Qadisiyah', 'القادسية': 'Qadisiyah',
    muthanna: 'Muthanna', 'al muthanna': 'Muthanna', MU: 'Muthanna', 'المثنى': 'Muthanna',
    saladin: 'Saladin', 'salah ad din': 'Saladin', 'salah al din': 'Saladin', SD: 'Saladin', 'صلاح الدين': 'Saladin',
    halabja: 'Halabja', HA: 'Halabja', 'حلبجة': 'Halabja'
  };
  var arabicProvinceNames = {
    Anbar: 'الأنبار', Basra: 'البصرة', Nineveh: 'نينوى', Erbil: 'أربيل', Sulaymaniyah: 'السليمانية',
    Duhok: 'دهوك', Kirkuk: 'كركوك', Najaf: 'النجف', Karbala: 'كربلاء', Baghdad: 'بغداد',
    Babil: 'بابل', Wasit: 'واسط', Diyala: 'ديالى', Maysan: 'ميسان', 'Dhi Qar': 'ذي قار',
    Qadisiyah: 'القادسية', Muthanna: 'المثنى', Saladin: 'صلاح الدين', Halabja: 'حلبجة'
  };

  function clean(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function provinceValue(value) {
    var normalized = clean(value).replace(/\b(governorate|province)\b/gi, '').replace(/محافظة/g, '').trim();
    return provinceAliases[normalized] || provinceAliases[normalized.toLowerCase()] || '';
  }

  function localizedProvinceName(value, locale) {
    var canonical = provinceValue(value);
    if (!canonical) return clean(value);
    return /^ar(?:-|$)/i.test(clean(locale)) ? arabicProvinceNames[canonical] || canonical : canonical;
  }

  function deliveryCity(city, province, locale) {
    var currentCity = clean(city);
    var canonicalProvince = provinceValue(province);
    if (!canonicalProvince) return currentCity || clean(province);
    var canonicalCity = provinceValue(currentCity);
    if (currentCity && canonicalCity !== canonicalProvince) return currentCity;
    return localizedProvinceName(canonicalProvince, locale);
  }

  function fullName(address, profile) {
    return clean(address.full_name || [address.first_name, address.last_name].filter(Boolean).join(' ') || profile.full_name || [profile.first_name, profile.last_name].filter(Boolean).join(' '));
  }

  function splitName(value) {
    var parts = clean(value).split(' ').filter(Boolean);
    if (!parts.length) return { firstName: '', lastName: '' };
    if (parts.length === 1) return { firstName: parts[0], lastName: parts[0] };
    return { firstName: parts.slice(0, -1).join(' '), lastName: parts[parts.length - 1] };
  }

  function addressText(address) {
    return [address.address1, address.address2].map(clean).filter(function (value, index, values) {
      return value && values.indexOf(value) === index;
    }).join(', ');
  }

  function normalizeAddress(address, profile, index) {
    var item = address || {};
    var name = fullName(item, profile);
    var parsedName = splitName(name);
    return {
      id: clean(item.id || item.address_id || ('rwady-' + index)),
      shopifyAddressId: clean(item.shopify_address_id),
      label: clean(item.label || item.address1 || item.city || name),
      name: name,
      firstName: clean(item.first_name || parsedName.firstName),
      lastName: clean(item.last_name || parsedName.lastName),
      phone: clean(item.phone || item.primary_phone || profile.primary_phone || profile.phone),
      email: clean(item.email || profile.email),
      province: provinceValue(item.province_code || item.provinceCode || item.province || item.city),
      address1: clean(item.address1),
      address2: clean(item.address2),
      city: clean(item.city),
      address: addressText(item),
      isDefault: Boolean(item.is_default || item.default || item.isDefault)
    };
  }

  function addressKey(address) {
    return [address.name, address.phone, address.province, address.address].map(function (value) {
      return clean(value).toLocaleLowerCase();
    }).join('|');
  }

  function normalizeAddresses(addresses, profile) {
    var seen = Object.create(null);
    return (Array.isArray(addresses) ? addresses : []).map(function (address, index) {
      return normalizeAddress(address, profile || {}, index);
    }).filter(function (address) {
      var key = addressKey(address);
      if (!address.address || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function loadAccountData(client) {
    return Promise.all([client.profile(), client.addresses()]).then(function (results) {
      var profile = results[0] && results[0].customer || {};
      var profileLinkState = clean(results[0] && results[0].shopify_link_state).toLowerCase();
      var addressLinkState = clean(results[1] && results[1].shopify_link_state).toLowerCase();
      var shopifyLinkState = addressLinkState || profileLinkState || 'linked';
      return {
        profile: profile,
        addresses: shopifyLinkState === 'linked' ? normalizeAddresses(results[1] && results[1].addresses, profile) : [],
        shopifyLinkState: shopifyLinkState
      };
    });
  }

  function setOptionData(option, address) {
    option.value = address.id;
    option.dataset.shopifyAddressId = address.shopifyAddressId;
    option.dataset.name = address.name;
    option.dataset.phone = address.phone;
    option.dataset.email = address.email;
    option.dataset.province = address.province;
    option.dataset.address = address.address;
    option.dataset.firstName = address.firstName;
    option.dataset.lastName = address.lastName;
    option.dataset.address1 = address.address1;
    option.dataset.address2 = address.address2;
    option.dataset.city = address.city;
  }

  function applyAddress(root, address, dirty) {
    if (!address) return;
    var values = { name: address.name, phone: address.phone, email: address.email, province: address.province, address: address.address };
    Object.keys(values).forEach(function (key) {
      var field = root.querySelector('[data-rwady-field="' + key + '"]');
      var value = values[key];
      if (!field || !value || dirty && dirty.has(key)) return;
      if (field.tagName === 'SELECT') {
        var match = Array.prototype.find.call(field.options, function (option) { return option.value === value; });
        if (!match) return;
        field.value = match.value;
      } else field.value = value;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      if (key === 'province') field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function applyAlternatePhone(root, profile, dirty) {
    var field = root.querySelector('[data-rwady-alternate-phone]');
    var value = clean(profile && profile.alternate_phone);
    if (!field || !value || dirty && dirty.has('alternate_phone')) return false;
    field.value = value;
    field.dataset.initialPhone = value;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    return true;
  }

  function addressIdentity(value) {
    var item = value || {};
    var shopifyId = clean(item.shopifyAddressId || item.shopify_address_id || item.dataset && item.dataset.shopifyAddressId);
    return {
      id: clean(item.id || item.value),
      shopifyKey: shopifyId.split('/').filter(Boolean).pop()?.split('?')[0] || ''
    };
  }

  function addressMatchesIdentity(address, identity) {
    var current = addressIdentity(address);
    return Boolean(identity && ((identity.id && current.id === identity.id)
      || (identity.shopifyKey && current.shopifyKey === identity.shopifyKey)));
  }

  function reconcileAddressSelection(addresses, identity) {
    if (!identity || (!identity.id && !identity.shopifyKey)) return { status: 'manual', address: null };
    var match = (Array.isArray(addresses) ? addresses : []).find(function (address) {
      return addressMatchesIdentity(address, identity);
    });
    return match ? { status: 'matched', address: match } : { status: 'account_changed', address: null };
  }

  function selectedAddressIdentity(root) {
    var select = root.querySelector('[data-rwady-saved-address]');
    var option = select && select.options && select.options[select.selectedIndex];
    return option && option.value ? addressIdentity(option) : null;
  }

  function clearStaleAddress(root) {
    ['name', 'email', 'province', 'address'].forEach(function (key) {
      var field = root.querySelector('[data-rwady-field="' + key + '"]');
      if (!field) return;
      field.value = '';
      field.dispatchEvent(new Event('input', { bubbles: true }));
      if (key === 'province') field.dispatchEvent(new Event('change', { bubbles: true }));
    });
    var alternatePhone = root.querySelector('[data-rwady-alternate-phone]');
    if (alternatePhone) {
      alternatePhone.value = '';
      alternatePhone.dataset.initialPhone = '';
      alternatePhone.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function render(root, addresses, dirty, options) {
    var settings = options || {};
    var picker = root.querySelector('[data-rwady-address-picker]');
    var select = picker && picker.querySelector('[data-rwady-saved-address]');
    var menu = picker && picker.querySelector('[data-rwady-address-menu]');
    var triggerLabel = picker && picker.querySelector('[data-rwady-address-trigger-label]');
    if (!select || !menu) return false;
    var rtl = root.dir === 'rtl';
    select.textContent = '';
    menu.textContent = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = rtl ? 'اختر عنوانًا محفوظًا' : 'Choose a saved address';
    select.appendChild(placeholder);
    if (!addresses.length) {
      if (triggerLabel) triggerLabel.textContent = rtl ? 'لا توجد عناوين محفوظة' : 'No saved addresses';
      if (settings.selectionRequired) picker.dataset.addressSelectionRequired = 'true';
      else delete picker.dataset.addressSelectionRequired;
      return true;
    }
    addresses.forEach(function (address) {
      var text = address.label + (address.isDefault ? (rtl ? ' — الافتراضي' : ' — Default') : '');
      var option = document.createElement('option');
      setOptionData(option, address);
      option.textContent = text;
      select.appendChild(option);
      var button = document.createElement('button');
      button.type = 'button';
      button.dataset.rwadyAddressChoice = address.id;
      button.textContent = text;
      menu.appendChild(button);
    });
    var selected = settings.selectedId && addresses.find(function (address) { return address.id === settings.selectedId; });
    if (!selected && settings.selectDefault !== false) selected = addresses.find(function (address) { return address.isDefault; });
    if (selected) {
      select.value = selected.id;
      triggerLabel.textContent = select.options[select.selectedIndex].textContent.trim();
      menu.querySelector('[data-rwady-address-choice="' + CSS.escape(selected.id) + '"]')?.classList.add('is-selected');
      if (settings.applySelected !== false) applyAddress(root, selected, dirty);
    } else {
      select.value = '';
      if (triggerLabel) triggerLabel.textContent = rtl ? 'اختر عنوانًا محفوظًا' : 'Choose a saved address';
    }
    if (settings.selectionRequired) picker.dataset.addressSelectionRequired = 'true';
    else delete picker.dataset.addressSelectionRequired;
    return true;
  }

  function setAuthoritativePickerState(root, enabled, authenticated) {
    var picker = root.querySelector('[data-rwady-address-picker]');
    var select = picker && picker.querySelector('[data-rwady-saved-address]');
    var trigger = picker && picker.querySelector('[data-rwady-address-trigger]');
    var login = picker && picker.querySelector('[data-rwady-login-trigger]');
    var menu = picker && picker.querySelector('[data-rwady-address-menu]');
    if (!picker || !select) return false;
    var signedIn = authenticated === true;
    var hasSavedAddresses = signedIn && enabled;
    picker.dataset.addressSource = 'account-api';
    picker.dataset.accountAuthenticated = String(signedIn);
    select.disabled = !hasSavedAddresses;
    select.hidden = true;
    if (trigger) {
      trigger.disabled = !hasSavedAddresses;
      trigger.hidden = !hasSavedAddresses;
    }
    if (login) login.hidden = hasSavedAddresses;
    if (!hasSavedAddresses && menu) menu.hidden = true;
    return true;
  }

  var initialized = typeof WeakSet === 'function' ? new WeakSet() : { has: function () { return false; }, add: function () {} };
  var states = typeof WeakMap === 'function' ? new WeakMap() : { get: function () { return null; }, set: function () {} };
  function initialize(root, dependencies) {
    if (!root || initialized.has(root)) return Promise.resolve(false);
    initialized.add(root);
    var dirty = new Set();
    render(root, [], dirty);
    setAuthoritativePickerState(root, false, false);
    root.addEventListener('input', function (event) {
      var field = event.target.closest && event.target.closest('[data-rwady-field]');
      if (field && event.isTrusted) dirty.add(field.dataset.rwadyField);
      if (event.target.matches && event.target.matches('[data-rwady-alternate-phone]') && event.isTrusted) dirty.add('alternate_phone');
    });
    var accountApi = dependencies && dependencies.accountApi || (typeof window !== 'undefined' && window.RwadyAccountApi);
    if (!accountApi) return Promise.resolve(false);
    var client = dependencies && dependencies.client || accountApi.createClient({ baseUrl: root.dataset.accountApiBase });
    states.set(root, { client: client, dirty: dirty });
    return loadAccountData(client).then(function (data) {
      applyAlternatePhone(root, data.profile, dirty);
      var rendered = render(root, data.addresses, dirty);
      setAuthoritativePickerState(root, data.addresses.length > 0, true);
      return rendered;
    }).catch(function () {
      setAuthoritativePickerState(root, false, false);
      return false;
    });
  }

  function refreshAfterAuthorization(root, dependencies) {
    if (!root) return Promise.reject(new Error('CHECKOUT_ROOT_REQUIRED'));
    var state = states.get(root) || {};
    var dirty = state.dirty || new Set();
    var accountApi = dependencies && dependencies.accountApi || (typeof window !== 'undefined' && window.RwadyAccountApi);
    var client = dependencies && dependencies.client || state.client || accountApi && accountApi.createClient({ baseUrl: root.dataset.accountApiBase });
    if (!client) return Promise.reject(new Error('ACCOUNT_API_UNAVAILABLE'));
    var picker = root.querySelector('[data-rwady-address-picker]');
    var identity = selectedAddressIdentity(root);
    var alreadyRequiresSelection = picker && picker.dataset.addressSelectionRequired === 'true';
    var load = dependencies && dependencies.loadAccountData || loadAccountData;
    var draw = dependencies && dependencies.render || render;
    var clear = dependencies && dependencies.clearStaleAddress || clearStaleAddress;
    var applyContact = dependencies && dependencies.applyAlternatePhone || applyAlternatePhone;
    var setPicker = dependencies && dependencies.setAuthoritativePickerState || setAuthoritativePickerState;
    return load(client).then(function (data) {
      if (data.shopifyLinkState && data.shopifyLinkState !== 'linked') {
        applyContact(root, data.profile, dirty);
        draw(root, [], dirty, { selectDefault: false });
        setPicker(root, false, true);
        states.set(root, { client: client, dirty: dirty });
        return {
          ok: true,
          accountChanged: false,
          selectionRequired: false,
          shopifyLinkPending: true,
          shopifyLinkState: data.shopifyLinkState,
          address: null
        };
      }
      var reconciliation = reconcileAddressSelection(data.addresses, identity);
      if (alreadyRequiresSelection && reconciliation.status === 'manual') {
        draw(root, data.addresses, dirty, { selectDefault: false, selectionRequired: true });
        setPicker(root, data.addresses.length > 0, true);
        return { ok: false, accountChanged: true, selectionRequired: true };
      }
      if (reconciliation.status === 'account_changed') {
        clear(root);
        applyContact(root, data.profile, dirty);
        draw(root, data.addresses, dirty, { selectDefault: false, selectionRequired: true });
        setPicker(root, data.addresses.length > 0, true);
        return { ok: false, accountChanged: true, selectionRequired: true };
      }
      // Opt in only after explicit sign-in; keep reconciliation and account-change guards above.
      var loginDefault = dependencies && dependencies.selectDefault === true && reconciliation.status === 'manual'
        ? data.addresses.find(function (address) { return address.isDefault; }) : null;
      applyContact(root, data.profile, dirty);
      draw(root, data.addresses, dirty, reconciliation.address ? {
        selectedId: reconciliation.address.id,
        selectDefault: false,
        applySelected: false
      } : { selectDefault: Boolean(loginDefault) });
      setPicker(root, data.addresses.length > 0, true);
      states.set(root, { client: client, dirty: dirty });
      return { ok: true, accountChanged: false, selectionRequired: false, shopifyLinkPending: false, shopifyLinkState: 'linked', address: reconciliation.address || loginDefault || null };
    });
  }

  function useOrderOnlyAfterAuthorization(root, dependencies) {
    if (!root) return { ok: true, selectionRequired: false, accountAccess: false };
    var state = states.get(root) || {};
    var dirty = state.dirty || new Set();
    var hadSelectedAccountAddress = Boolean(selectedAddressIdentity(root));
    var clear = dependencies && dependencies.clearStaleAddress || clearStaleAddress;
    var draw = dependencies && dependencies.render || render;
    var setPicker = dependencies && dependencies.setAuthoritativePickerState || setAuthoritativePickerState;
    if (hadSelectedAccountAddress) clear(root);
    draw(root, [], dirty, { selectDefault: false, selectionRequired: hadSelectedAccountAddress });
    setPicker(root, false, false);
    states.set(root, { client: state.client, dirty: dirty });
    return {
      ok: !hadSelectedAccountAddress,
      accountAccess: false,
      accountChanged: hadSelectedAccountAddress,
      selectionRequired: hadSelectedAccountAddress,
      address: null
    };
  }

  function initializePage() {
    if (typeof document === 'undefined') return;
    initialize(document.querySelector('[data-rwady-checkout-information]'));
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePage, { once: true });
    else initializePage();
    document.addEventListener('maximize:cart:updated', initializePage);
  }

  return {
    provinceValue: provinceValue,
    localizedProvinceName: localizedProvinceName,
    deliveryCity: deliveryCity,
    normalizeAddress: normalizeAddress,
    normalizeAddresses: normalizeAddresses,
    loadAccountData: loadAccountData,
    applyAddress: applyAddress,
    applyAlternatePhone: applyAlternatePhone,
    addressIdentity: addressIdentity,
    reconcileAddressSelection: reconcileAddressSelection,
    selectedAddressIdentity: selectedAddressIdentity,
    clearStaleAddress: clearStaleAddress,
    render: render,
    setAuthoritativePickerState: setAuthoritativePickerState,
    initialize: initialize,
    refreshAfterAuthorization: refreshAfterAuthorization,
    useOrderOnlyAfterAuthorization: useOrderOnlyAfterAuthorization
  };
}));
